import { ResizeObserver as ResizeObserverFn } from "@juggle/resize-observer";
const ResizeObserver = window.ResizeObserver || ResizeObserverFn;
export class ElementSizeDetector {
    constructor() {
        this.ro = new ResizeObserver((entries) => {
            const entry = entries.length === 1 ? entries[0] : undefined;
            if (entry) {
                this.callback(entry.contentRect);
            }
        });
    }
    connect(element, callback) {
        this.callback = callback;
        this.ro.observe(element);
    }
    disconnect() {
        this.ro.disconnect();
    }
}
